module.exports = __webpack_public_path__ + "img/create-icon.0817e375.svg";